import React, { useState } from "react";
import "../styles/Companies.css";

const Companies = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [sortBy, setSortBy] = useState("None");

  const companies = [
    {
      name: "Meta",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MAANMG",
      logo: "../meta.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Apple",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MAANMG",
      logo: "../apple.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Amazon",
      rating: 4.5,
      description: "E-commerce and cloud computing giant.",
      location: "Seattle, WA",
      employees: 1500000,
      industry: "E-Commerce & Cloud",
      category: "MAANMG",
      logo: "../amazon.png",
      jobs: ["Web Developer", "Cloud Engineer", "Marketing Manager"],
      website: "https://www.amazon.jobs",
    },
    {
      name: "Google",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MAANMG",
      logo: "../google.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Netflix",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MAANMG",
      logo: "../netflix.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Microsoft",
      rating: 4.7,
      description: "Building software solutions worldwide.",
      location: "Redmond, WA",
      employees: 220000,
      industry: "Software & Cloud",
      category: "MAANMG",
      logo: "../microsoft.png",
      jobs: ["AI Engineer", "Frontend Developer", "Product Manager"],
      website: "https://careers.microsoft.com",
    },
    {
      name: "OpenAI",
      rating: 4.9,
      description: "Pioneering artificial intelligence research.",
      location: "San Francisco, CA",
      employees: 500,
      industry: "AI Research",
      category: "Startup",
      logo: "../openai.png",
      jobs: ["ML Engineer", "Data Scientist", "AI Researcher"],
      website: "https://openai.com/careers",
    },
    {
      name: "Adobe",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../adobe.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Flipkart",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../flipkart.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Intel",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../intel.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Cisco",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../cisco.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "HP",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../hp.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "IBM",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../ibm.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Intuit",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../intuit.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Oracle",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../oracle.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "VMware",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../vmware.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "LinkedIn",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../linkedin.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Uber",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../uber.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Amdocs",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../amdocs.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Walmart Labs",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../walmart.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Atlassian",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../atlassian.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "BMC Software",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../bmc.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "PayPal",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../paypal.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
    {
      name: "Accenture",
      rating: 4.8,
      description: "A global leader in technology.",
      location: "Mountain View, CA",
      employees: 150000,
      industry: "Tech & AI",
      category: "MNC",
      logo: "../accenture.png",
      jobs: ["Software Engineer", "Data Scientist", "UX Designer"],
      website: "https://careers.google.com",
    },
  ];

  // **Filtering Logic**
  const filteredCompanies = companies
    .filter((company) =>
      company.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      company.industry.toLowerCase().includes(searchQuery.toLowerCase()) ||
      company.location.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .filter((company) => categoryFilter === "All" || company.category === categoryFilter)
    .sort((a, b) => {
      if (sortBy === "Highest Rating") return b.rating - a.rating;
      if (sortBy === "Most Employees") return b.employees - a.employees;
      return 0;
    });

  return (
    <div className="companies-page">
      <h1>🚀 Explore Top Companies</h1>

      {/* Search and Filters Section */}
      <div className="filters">
        <input
          type="text"
          placeholder="🔍 Search by company, industry, or location..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-bar"
        />

        <select onChange={(e) => setCategoryFilter(e.target.value)} className="filter-dropdown">
          <option value="All">All Categories</option>
          <option value="MAANMG">MAANMG</option>
          <option value="MNC">MNC</option>
          <option value="Startup">Startups</option>
        </select>

        <select onChange={(e) => setSortBy(e.target.value)} className="filter-dropdown">
          <option value="None">Sort By</option>
          <option value="Highest Rating">Highest Rating</option>
          <option value="Most Employees">Most Employees</option>
        </select>
      </div>

      {/* Company List */}
      <div className="companies-list">
        {filteredCompanies.map((company, index) => (
          <div key={index} className="company-card">
            <img src={company.logo} alt={company.name} className="company-logo" />
            <h2>{company.name}</h2>
            <p><strong>Industry:</strong> {company.industry}</p>
            {/* <p><strong>Location:</strong> {company.location}</p> */}
            <p><strong>Employees:</strong> {company.employees.toLocaleString()}</p>
            <p><strong>Rating:</strong> ⭐ {company.rating}</p>
            <p>{company.description}</p>

            {/* <h3>💼 Available Jobs:</h3>
            <ul className="job-list">
              {company.jobs.map((job, idx) => (
                <li key={idx} className="job-item">{job}</li>
              ))}
            </ul> */}

            <a href={company.website} target="_blank" rel="noopener noreferrer" className="visit-link">
              Visit Website 🌐
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Companies;
